import * as React from 'react';

import { PrimitiveTabs } from 'components';
import { useCategoryAction, useCategoryValue } from 'context';

import { CategoryBaseInfo } from './base-info';
import { CategorySeoInfo } from './seo-info';

const CategoryFormTabs = () => {
  const { step = 1 } = useCategoryValue();
  const action = useCategoryAction();

  return (
    <PrimitiveTabs
      items={[
        {
          key: '1',
          label: 'اطلاعات اولیه',
          children: <CategoryBaseInfo />,
        },
        {
          key: '2',
          label: 'تنظیمات سئو',
          children: <CategorySeoInfo />,
          disabled: step < 2,
        },
      ]}
      activeKey={step.toString()}
      onChange={activeKey => {
        action({
          type: 'UPDATE_CATEGORY_STEP',
          payload: {
            step: +activeKey as typeof step,
          },
        });
      }}
    />
  );
};

export { CategoryFormTabs };
